<fav-heart
  [pageviewId]="pageviewId"
  [flow]="flow"
  [data]="favData"
  [options]="{ noBorder: false, white: true }"
  [product]="product"
  [locale]="locale"
  [clientType]="getViewType()"
  [originGid]="cityGid"
  [destinationGid]="cityGid"
  [xClient]="xClient"
  [tripPlannerEnabled]="tripPlannerEnabled"
>
</fav-heart>